<template>
  <div>

    <div class="col-lg-12 p-b-5">
      <ul class="list-group account-group">
        <li class="list-group-item col-xs-12">
          <label>

            <input v-if="!is_unavailable" type="checkbox" v-model="account_selected"
                   @change="select_account">
            # {{ account_nbr }} <span
              v-show="hasApproved"> - {{ account_nm }} ({{ city }}, {{ state_cd }}) </span>
            <span v-show="hasPendingApproval" class="label label-warning m-l-5">Waiting Approval</span>
          </label>

          <div class="pull-right m-t-0 m-r-10">
            <span v-if="didRolesChange">
                <button class="btn btn-primary btn-bold m-l-10"
                        @click="saveMyAccount" :class="{ disabled : is_processing }">
                    Request from Admin
                </button>
                <account-password-add
                    :account_nbr="account_nbr"
                    :user_account_roles="user_account_roles"
                    @approveAccountRoles="approveAccountRoles"
                ></account-password-add>

            </span>
            <span v-else-if="needSave">
                <button v-if="needSave" class="btn btn-primary btn-bold m-l-10"
                        @click="saveMyAccount" :class="{ disabled : is_processing }">
                    Save Permissions
                </button>
            </span>
          </div>

        </li>

      </ul>
      <div>
        <div class="row">
          <div class="col-xs-12">
            <ul class="list-group-item user-account-group">
              <li></li>

              <account-role-item
                  v-for="(role,index) in all_roles"
                  :type="'request'"
                  :is_unavailable="is_unavailable"
                  :role_cd="role.role_cd"
                  :role_desc="role.role_desc"
                  :user_account_roles="user_account_roles"
                  @add="addRole"
                  @delete="deleteRole"
              ></account-role-item>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  module.exports = {
    props: [
      'account_nbr',
      'account_nm',
      'city',
      'state_cd',
      'user_account_roles',
      'all_roles',
      'index',
      'is_unavailable',
    ],

    data: function () {
      return {
        account_selected: true,
        saved_roles: {},
        field_errors: {},
        is_processing: false
      }
    },
    computed: {
      hasApproved() {
        if (this.is_unavailable == 1) {
          return false;
        }
        var roleKeys = Object.keys(this.user_account_roles);
        for (var i = 0; i < roleKeys.length; i++) {
          if (this.user_account_roles[roleKeys[i]] == 0) {
            return true;
          }
        }
        return false;
      },

      didRolesChange() {
        if (this.is_unavailable == 1) {
          return false;
        }
        var roleKeys = Object.keys(this.user_account_roles);
        var savedKeys = Object.keys(this.saved_roles);
        for (var i = 0; i < roleKeys.length; i++) {
          if (savedKeys && savedKeys.indexOf(roleKeys[i]) != -1) {
            if (parseInt(this.saved_roles[roleKeys[i]]) != parseInt(this.user_account_roles[roleKeys[i]]))
              return true;
          } else {
            return true;
          }
        }
        return false;
      },

      needSave() {
        return (Object.keys(this.user_account_roles).length
            == Object.keys(this.saved_roles).length) ? false : true;
      },


      hasPendingApproval() {
        var roleKeys = Object.keys(this.user_account_roles);
        for (var i = 0; i < roleKeys.length; i++) {
          if (this.user_account_roles[roleKeys[i]] == 1) {
            return true;
          }
        }
        return false;
      }

    },
    methods: {
      select_account: function () {
        if (!this.account_selected) {
          this.$emit('unselect', this.index);
        }
      },

      addRole: function (role_cd) {
        this.account_selected = true;
        var isRoleApproved = 1;
        if (this.saved_roles[role_cd] == 0) {
          isRoleApproved = 0;
        }
        this.$emit('add', {
          account_index: this.index,
          role_cd: role_cd,
          approved: isRoleApproved
        });
      },
      deleteRole: function (role_cd) {
        this.$emit('delete', {
          account_index: this.index,
          role_cd: role_cd
        });
      },
      approveAccountRoles: function (user_account) {
        var parms = {
          account_index: this.index,
          user_account: user_account
        };
        this.$emit('approve', parms, this.setOriginalRoles(true));
      },

      saveMyAccount: function () {
        this.field_errors = {}
        this.is_processing = true

        this.$http.post('/my/account-roles/request',
            {
              'account_nbr': this.account_nbr,
              'roles': this.user_account_roles
            })
            .then(function (response) {
              this.setOriginalRoles(true);
              this.is_processing = false
            })
            .catch(function (data, status, request) {
              this.$set(this.field_errors, 'request', 'Error saving. Please try again.')
              this.is_processing = false
            })
      },

      setOriginalRoles: function (resetPending) {

        this.$nextTick(function () {
          this.saved_roles = Object.assign({}, this.user_account_roles)
        });
      }
    },
    mounted: function () {
      this.setOriginalRoles(false);
    }
  }

</script>






// WEBPACK FOOTER //
// my-account-role-list.vue?7f2dffa8